require('./src/styles/global.css')

exports.wrapPageElement = require('./src/wrapPage').default
